import {FunnelType} from "./CJmapManager";
import {CjmapCells} from "./CjmapCells";
import {CjmapPersona} from "./CjmapPersona";

export class SerializableJourneyMap {
    static readonly __CLASS__ = 'SerializableJourneyMap';

    public title: string;
    public background_key: string;
    public color_scheme_key: string;
    public funnel_type: FunnelType;
    public cells: CjmapCells;
    public persona: CjmapPersona;

    constructor(title: string, background_key: string, color_scheme_key: string, funnel_type: FunnelType, cells: CjmapCells, persona: CjmapPersona) {
        this.title = title;
        this.background_key = background_key;
        this.color_scheme_key = color_scheme_key;
        this.funnel_type = funnel_type;
        this.cells = cells;
        this.persona = persona;
    }

    /**
     * @see  CJMapManager.toJourneyMapJSON
     *
     * @param obj
     */
    static fromJSON(obj: any) {

        // persona は後から追加されたので、含まれていないことがある
        const persona = (obj.persona === undefined) ? CjmapPersona.createDefaultPersona() : CjmapPersona.fromJSON(obj.persona);

        return new SerializableJourneyMap(
            obj.title,
            obj.background_key,
            obj.color_scheme_key,
            obj.funnel_type,
            CjmapCells.fromJSON(obj.cells),
            persona
        );
    }

    static fromJSONString(json_string: string) {
        return SerializableJourneyMap.fromJSON(JSON.parse(json_string));
    }
}
